<template>
<popup :showFlag="showFlag"
       @onShowpop="onClose">
  <div class="cont">
    <img @click="onClose" src="@/assets/icon_del.png" class="close"/>
    <div class="pimgurlwrap">
      <img :src="imgurl" :style="{'background-image':'linear-gradient(to bottom,#'+allColor[coloridx].s_color+ ',#'+allColor[coloridx].e_color+')'}" class="pimgurl"/>
    </div>
    <div class="infogroup">
      <div class="specname oneline">{{specName}}</div>
      <div class="payinfo">包含「单张电子照」{{canprint?'和「排版照」':''}}</div>
      <div class="yixuan">
        已选底色
        <div v-show="paytype==='ele'"
             v-for="item in chooseColor"
             :key="item.color_name"
             class="coritem"
             :style="{'background-image':'linear-gradient(to bottom,#'+item.s_color+',#'+item.e_color+')'}">
        </div>
      </div>
      <div class="price" v-if="paytype==='ele'">￥{{price['1']}}</div>
    </div>
    <div class="kexuan">
      可选服务
    </div>
    <div class="servicegroup">
      <div class="seritem" :class="[(selVal&2)===2?'activeservice':'']" @click="buy('2')">
        个性换正装<span class="pricetxt">￥{{price['2']}}</span>
      </div>
      <div class="seritem" :class="[(selVal&4)===4?'activeservice':'']" v-if="allColor.length>1&&paytype==='ele'" @click="buy('4')">
        保存{{allColor.length}}种底色<span class="pricetxt">￥{{price['4']}}</span>
        <img src="./img/xuanze.png" class="xz"/>
      </div>
    </div>
    <div class="paybtn"
         @click="collectpay">
      <span>支付 {{price[selVal.toString()]}}元 保存电子照</span>
    </div>
  </div>
</popup>
</template>

<script>
import popup from '@/components/popup'
import { mapState, mapActions } from 'vuex'
import { MessageBox, Toast } from 'mint-ui'
export default {
  name: 'pay',
  props: {
    paytype: {
      default: 'ele',
      type: String
    },
    showFlag: {
      default: false,
      type: Boolean
    },
    imgurl: {
      default: '',
      type: String
    },
    specName: {
      default: '',
      type: String
    },
    project_no: {
      default: '', // 判断是否是收集照片功能
      type: String
    },
    canprint: {
      default: true,
      type: Boolean
    },
    chooseColor: {
      default: () => [],
      type: Array
    },
    price: {
      default: () => {},
      type: Object
    },
    allColor: {
      default: () => [],
      type: Array
    },
    chooseKey: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      selVal: 5, // 1为基础价个2为换正装价格3为基础加换正装价格4为多背景价格5为基础加多背景价格7为基础加正装加多背景价格
      coloridx: 0,
      orderid: ''
    }
  },
  destroyed () {
    console.log('pay组件没有了')
    this.$bus.off('payInit')
  },
  created () {
    this.$bus.on('payInit', this.inipayData)
  },
  methods: {
    ...mapActions(['collectPayA', 'getCollectPayA']),
    inipayData () {
      this.initmeobj()
      let val = 5
      const { coloridx } = this.makePhotoInfo
      console.log('chooseKey:::', this.chooseKey)
      const obj = {
        coloridx
      }
      if (this.chooseColor.length === 1) {
        val -= 4
      }
      if (this.chooseKey) {
        val += 2
      }
      obj.selVal = val
      console.log('val:::', val)
      this.setData(obj)
    },
    initmeobj () {
      this.meobj = {
        singlebol: true // 防连点
      }
    },
    onClose () {
      this.$emit('onClosePay')
    },
    buy (val) {
      let selVal = this.selVal
      val = +val
      const bijiao = selVal & val
      let isprevent = false
      if (bijiao === val) {
        // 取消选中
        selVal -= val
        isprevent = this.valopr(val, false)
      } else {
        // 选中
        selVal += val
        isprevent = this.valopr(val, true)
      }
      console.log(isprevent)
      if (isprevent) {
        return
      }
      this.selVal = selVal
    },
    valopr (val, bol) {
      // bol为true时选中false为取消选中
      let res = true
      if (val === 4) {
        // 选了多背景
        res = this.needAll(bol)
      } else if (val === 2) {
        // 选了换装
        res = this.needClose(bol)
      }
      return res
    },
    needAll (bol) {
      // 选择多背景操作
      this.$emit('onChooseAll', bol)
    },
    needClose (bol) {
      if (!this.makePhotoInfo.clothes_path) {
        MessageBox({
          title: '您还未选择正装模板哦',
          message: '您未选择正装模版，快去为自己换一套精致的正装吧~',
          showCancelButton: true,
          confirmButtonText: '去换装'
        }).then((res) => {
          this.$bus.emit('bk_openclose')
          res === 'confirm' && this.$router.go(-1)
        })
        return true
      }
      this.$emit('onChooseClose', bol)
    },
    setData (obj) {
      Object.keys(obj).forEach(item => {
        this[item] = obj[item]
      })
    },
    joinpayHandle () {
      const { project_no, orderid } = this
      // 参与者支付完的操作
      this.$bus.emit('jt_jointeam', project_no, orderid)
      this.$emit('onGetjoindetail')
    },
    ownerpayHandle () {
      const { project_no } = this
      // 创建者不可见活动支付完的操作
      this.$bus.emit('mt_actualnum', project_no)
      setTimeout(() => {
        this.$router.go(-2)
      }, 1500)
    },
    coiosAction () {
      const { is_visible } = this.makePhotoInfo
      const fnname = is_visible === 1 ? this.ownerpayHandle : this.joinpayHandle
      fnname.call(this)
      Toast({
        message: '已发送至审核者',
        iconClass: 'icon icon-success'
      })
    },
    tradePay (data) {
      const { appId, nonceStr, package: pkg, paySign, signType, timeStamp } = data
      return new Promise((resolve, reject) => {
        wx.chooseWXPay({
          timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr, // 支付签名随机串，不长于 32 位
          package: pkg, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign, // 支付签名
          success: function (res) {
            resolve(res)
          },
          fail (err) {
            console.log('err:::', err)
            reject(err)
          }
        })
      })
    },
    collectpay () {
      const { chooseKey } = this
      this.$emit('onClosePay')
      this.collectPayA(chooseKey).then(res => {
        const { order_id, is_pay } = res
        this.orderid = order_id
        if (is_pay === 0) {
          this.coiosAction()
          return
        }
        this.getCollectPayA(order_id).then(res => {
          const { pay } = res
          console.log('支付:::', pay)
          return this.tradePay(pay)
        }).then(res => {
          this.coiosAction()
        }).catch(err => {
          console.log('啥错误:::', err)
          const msg = typeof err === 'string' ? err : '支付失败'
          Toast({
            message: msg,
            duration: 2000
          })
        })
      })
    }
  },
  components: {
    popup
  },
  computed: {
    ...mapState(['makePhotoInfo', 'actiBol'])
  }
}
</script>

<style scoped>
.cont{
  background-color: white;
  padding: 1.02rem .48rem .35rem;
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  position:relative;
  overflow: hidden;
}
.close{
  width:.42rem;
  border:.1rem solid transparent;
  position: absolute;
  right:.32rem;
  top:.32rem;
}
.pimgurlwrap{
  width:1.76rem;
  height:2.46rem;
  object-fit: cover;
  float: left;
  margin-right: .48rem;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.pimgurl{
  width:100%;
  max-height:100%;
  object-fit: contain;
}
.infogroup{
  overflow: hidden;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  height:2.46rem;
}
.specname{
  flex-basis: 100%;
  font-size: .32rem;
  color:#303133;
  margin-bottom: .12rem;
}
.payinfo{
  flex-basis: 100%;
  font-size: .24rem;
  color:rgba(48, 49, 51, 0.4);
  word-break: break-all;
  margin-bottom: .32rem;
}
.yixuan{
  padding:0 .24rem;
  border-radius: .16rem;
  background-color: #F5F7FA;
  display: flex;
  display: -webkit-flex;
  height:.64rem;
  align-items: center;
  font-size: .24rem;
  color:#303133;
}
.coritem:first-child{
  margin-left: .32rem;
}
.coritem{
  width:.24rem;
  height:.24rem;
  border-radius: 50%;
  margin-right: .16rem;
}
.price{
  flex-basis: 100%;
  align-self: flex-end;
  font-size: .32rem;
  color:#FF5555;
}
.kexuan{
  font-size: .26rem;
  color:#303133;
  border-top:.02rem solid #E5E5EA;
  margin: .48rem 0 .38rem;
  padding-top: .32rem;
}
.servicegroup{
  display: flex;
  display: -webkit-flex;
}
.seritem{
  width:3.13rem;
  height:.8rem;
  border-radius: .12rem;
  background-color: #F5F7FA;
  text-align: center;
  line-height: .8rem;
  color:#2A292E;
  font-size: .24rem;
  position:relative;
  box-sizing: border-box;
  border:.02rem solid transparent;
}
.xz{
  width:1.6rem;
  /* height:.36rem; */
  position:absolute;
  top:-.3rem;
  right:.52rem;
}
.seritem:first-child{
  margin-right: .3rem;
}
.pricetxt{
  padding-left: .28rem;
  border-left: .02rem solid #E5E5EA;
  margin-left: .28rem;
}
.paybtn{
  width:6.86rem;
  height:.96rem;
  border-radius: .12rem;
  background-color: #4710ED;
  font-size: .34rem;
  color:white;
  text-align: center;
  line-height: .96rem;
  margin:.64rem auto 0;
}
.activeBtn{
  background-color: rgba(71, 16, 237, 0.6);
}
.activeservice{
  border:.02rem solid #4710ED;
  background-color: rgba(71, 16, 237, 0.05);
  color:#4710ED;
}
</style>
